import React from "react";

export default data => {
    const listOfTags = [];

    data.tags.forEach(el => {
        if (el.attributes === null || el.tagName !== "meta") {
            return;
        }

        if (el.attributes.property) {
            listOfTags.push(
                <meta
                    key={el.attributes.property}
                    property={el.attributes.property}
                    content={el.attributes.content}
                />
            );
            return;
        }

        listOfTags.push(
            <meta
                key={el.attributes.name}
                name={el.attributes.name}
                content={el.attributes.content}
            />
        );
    });

    return listOfTags;
};
